import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { FieldVerificationFieldVerificationSendSmsFailureActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function FieldVerificationSendSmsFailure({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as FieldVerificationFieldVerificationSendSmsFailureActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》短信验证码签名审核失败</ItemWrapper>
}
